import React from 'react';
import _ from 'lodash';
import CustomToggle from '../../stepper/CustomToggle';

const LinkOrganizationStatus = (props) => {
  const { handleActiveStep, result, index } = props;
  return (
    <div>
      <span className="stepper__step-link">
        <strong>{_.get(result, ['googleOrganization', 'displayName'])}</strong>
        <br />
      </span>
      <CustomToggle variant="link" eventKey={`${index}`} isValid="true" handleActiveStep={handleActiveStep} className="fs-6">
        Link a different organization
      </CustomToggle>
    </div>
  );
};

export default LinkOrganizationStatus;
